(function () {
  'use strict';

  function getLocale() {
    var html = document.documentElement;
    return (html.lang || html.getAttribute('lang') || 'en').slice(0, 2).toLowerCase();
  }

  function starSvg(filled) {
    var opacity = filled ? '1' : '0.22';
    return (
      '<svg class="ted-review-card__star" viewBox="0 0 20 20" fill="currentColor" style="opacity:' +
      opacity +
      '" aria-hidden="true"><path d="M10 1.5l2.47 5.01 5.53.8-4 3.9.94 5.5L10 14.77l-4.94 2.6.94-5.5-4-3.9 5.53-.8L10 1.5z"/></svg>'
    );
  }

  function renderStars(rating) {
    var html = '';
    for (var i = 1; i <= 5; i++) {
      html += starSvg(i <= rating);
    }
    return '<span class="ted-review-card__stars" aria-label="' + rating + '/5">' + html + '</span>';
  }

  function childLabel(review, locale) {
    if (locale === 'fr') {
      return review.child + ', ' + review.age + ' ans';
    }
    return review.child + ', ' + review.age + ' years old';
  }

  function renderCard(review, locale) {
    var comment = locale === 'fr' ? review.comment_fr : review.comment_en;
    return (
      '<article class="ted-review-card">' +
      renderStars(review.rating) +
      '<blockquote class="ted-review-card__quote"><p>' +
      escapeHtml(comment) +
      '</p></blockquote>' +
      '<footer class="ted-review-card__footer">' +
      '<p class="ted-review-card__parent">' +
      escapeHtml(review.parent) +
      '</p>' +
      '<p class="ted-review-card__child">' +
      escapeHtml(childLabel(review, locale)) +
      '</p>' +
      '</footer>' +
      '</article>'
    );
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function initPage() {
    var grid = document.querySelector('[data-ted-reviews-grid]');
    if (!grid) return;

    var dataEl = document.querySelector('[data-ted-reviews-data]');
    if (!dataEl) return;

    var url = dataEl.getAttribute('data-ted-reviews-data');
    var locale = getLocale();

    fetch(url)
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        var reviews = data.reviews || [];
        if (!reviews.length) {
          grid.innerHTML = '';
          return;
        }
        grid.innerHTML = reviews.map(function (r) {
          return renderCard(r, locale);
        }).join('');
      })
      .catch(function () {
        grid.innerHTML = '';
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPage);
  } else {
    initPage();
  }
})();
